import React, { useContext } from 'react'
import { useLocation } from 'react-router-dom'

// capture query string args on initial page load (e.g. redirect_to) so that we can
// reference them when linking to sign-in flows
const initialQueryStringParameters = Object.fromEntries(new URLSearchParams(window.location.search))
const InitialQueryStringParametersContext = React.createContext(initialQueryStringParameters)
const useInitialQueryStringParameters = () => useContext(InitialQueryStringParametersContext)

// capture query string args on current page
const useQueryStringParameters = () => Object.fromEntries(new URLSearchParams(useLocation().search).entries())

export { useInitialQueryStringParameters, useQueryStringParameters }
